var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.768 18.3908H4.23101C3.57534 18.3908 2.94652 18.1274 2.48289 17.6586C2.01925 17.1898 1.75879 16.5539 1.75879 15.8908V2.5575C1.75879 2.33649 1.84561 2.12452 2.00015 1.96824C2.1547 1.81196 2.3643 1.72417 2.58286 1.72417H14.1199C14.3384 1.72417 14.5481 1.81196 14.7026 1.96824C14.8571 2.12452 14.944 2.33649 14.944 2.5575V12.5575H18.2403V15.8908C18.2403 16.5539 17.9798 17.1898 17.5162 17.6586C17.0525 18.1274 16.4237 18.3908 15.768 18.3908ZM14.944 14.2242V15.8908C14.944 16.1118 15.0308 16.3238 15.1853 16.4801C15.3399 16.6364 15.5495 16.7242 15.768 16.7242C15.9866 16.7242 16.1962 16.6364 16.3507 16.4801C16.5053 16.3238 16.5921 16.1118 16.5921 15.8908V14.2242H14.944ZM13.2958 16.7242V3.39083H3.40694V15.8908C3.40694 16.1118 3.49376 16.3238 3.6483 16.4801C3.80285 16.6364 4.01245 16.7242 4.23101 16.7242H13.2958ZM5.05508 5.89083H11.6477V7.5575H5.05508V5.89083ZM5.05508 9.22417H11.6477V10.8908H5.05508V9.22417ZM5.05508 12.5575H9.17545V14.2242H5.05508V12.5575Z",
    fill: "#737373"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/documentIcon.f237db567e03f42f650eb8b7f09bb206.svg";
export { ForwardRef as ReactComponent };